<template>
  <div class='recode-main'>
   <div class="fixed">
            <div class="obj">评价对象</div>
            <!--指标项-->
            <div class="text">指标项</div>
            <!--得分-->
            <div class="source">得分</div>
            <!--评价人员-->
            <div class="obj person">评价人员</div>
            <!--时间-->
            <div class="obj time">评价时间</div>
          </div>
    <van-pull-refresh v-model="isLoading" @refresh="onRefresh" style="margin-top:10px;">
      <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="getList">
        <div class="list">
         
          <div v-for="(item,index) in list"  :key="index" class="list-item">
          <!--评价对象-->
          <div class="obj">
              {{item.RecordObjectName}}
          </div>
          <!--指标项-->
          <div class="text">
            {{item.IndexManagementName}}
          </div>
          <!--得分-->
          <div class="source">{{item.ScoringValue}}</div>
            <!--评价人员-->
          <div class="person obj">{{item.LastModifyUserName}}</div>
            <!--时间-->
          <div class="time obj">{{item.LastModifyByDate}}</div>
          </div>
        </div>
      </van-list>
    </van-pull-refresh>
  </div>
</template>
<script>
  export default {
    name: '',
    data () {
      return {
        params:{},
        current:1,
        list:[],
        loading: false, // 是否加载中
        finished: false, // 加载是否完成
        isLoading: false, //是否处于下拉刷新状态
      }
    },
    created () {
      this.params = this.$store.state.evaluation.ipadAverageObj
      // this.getList()
    },
    mounted () {},
    methods:{
      onRefresh() {
        setTimeout(() => {
          this.list = [];
          this.current= 1;
          this.isLoading = false;
          this.getList();
        }, 500);
      },
      async getList(){
           this.xyapi.get(`${this.$store.state.apiPath}/api/EvaluateStudent/GetRecordLog`, {
          coursePlanAID: this.params.CoursePlanAID,
          coursePlanAIDType: this.params.CoursePlanAIDType,
          classTableGenerateBaseID: this.params.ClassTableGenerateBaseID,
          pageIndex: this.current,
          name: '',
          pageSize: 15,
        }).then(res => {
        let _list = res.data.data
        this.list = [...this.list, ..._list];
        this.loading = false;
        this.current++;
        this.finished = this.list.length >= res.data.totalRecords ? true : false;
       
      })
    }
  }
  }
</script>
<style lang='less' scoped>
.fixed{
  display: flex;
  position: fixed;
  top: 44px;
  left:0;
  right: 0;
  font-size: 14px;
  height:50px;
  z-index: 1;
  background:  #eaeaea;
  line-height: 50px;
  font-weight: 500;
  text-align: center;
  .obj{
    width:200px;
  }
}
.list{
  padding-top:50px;
}
.list-item{
  display: flex;
  font-size: 14px;
  border-bottom: 1px solid #eaeaea;
  height: 50px;
  line-height: 50px;
}
.obj{
  width: 200px;
  text-align: center;
  overflow: hidden;
  text-overflow:ellipsis;
  white-space: nowrap;
}
.text{
   max-width:500px;
   width: 350px;
  overflow: hidden;
  text-overflow:ellipsis;
  white-space: nowrap;
  text-align: center;
}
.source{
  width: 80px;
  text-align: center;
}
/deep/ .van-list__finished-text {
  font-size: 18px;
}
/deep/ .van-loading__text{
font-size: 18px;
}
/deep/ .van-pull-refresh__head{
  font-size: 18px;
}
</style>
